module.exports = __webpack_public_path__ + "img/dropsmith-kocevar-glavac.d17af99e.png";